import { useObservable } from "../../utils/observable";
import { useObservablePaginated } from "../../utils/observable-paginated";
import { useAsyncEffect } from "../../utils/utils";
import type { Mandate } from "./mandate";
import type { MandatesManager } from "./mandates-manager";

export default function useMandates(mandatesManager: MandatesManager) {
  const paginatedMandates = useObservablePaginated<Mandate>(mandatesManager.paginatedMandates);

  const canLoadMore = useObservable<boolean>(mandatesManager.canLoadMore);
  const isLoading = useObservable<boolean>(mandatesManager.isLoading);

  useAsyncEffect(async () => {
    await mandatesManager.getMandates();
  }, []);

  return {
    mandates: paginatedMandates.items,
    canLoadMore,
    isLoading,
    refresh: async () => await mandatesManager.getMandates(),
    getMandates: async () => await mandatesManager.getMandates(),
    loadMore: async () => await mandatesManager.loadMore(),
  };
}
